<template>
    <client-page>
        <page-section class="page-section--first">
            <div class="tit-wrap">
                <h2 class="tit tit--lg text-center">
                    리본바이옴은 <span class="primary--text">20년 전통의 건강기능식품 전문제조브랜드</span>로, <br class="d-none d-lg-block" />
                    파트너 여러분께 안정적인 수익 기회와 성장 지원을 제공합니다.
                </h2>
            </div>
            <v-row>
                <v-col v-for="(item, index) in items" :key="index" cols="6" lg="3">
                    <v-card rounded="xl" class="partner-card">
                        <div>
                            <v-card-title class="justify-center">
                                <h3 class="tit tit--xs primary--text text--darken-1">
                                    {{ item.title }}
                                </h3>
                            </v-card-title>
                            <v-card-text class="text-center pt-2">
                                <p v-html="item.text" class="txt grey--text text--darken-4 font-weight-medium" />
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
            <div class="btn-wrap btn-wrap--lg d-flex justify-center">
                <v-btn to="/join" color="primary" class="v-size--xx-large">
                    <span class="font-weight-bold">파트너 등록하기</span>
                    <v-img src="/images/icon/icon-arrow-right.svg" alt="" class="ml-10px" />
                </v-btn>
            </div>
        </page-section>

        <page-section>
            <template #tit>파트너 등록 <span class="primary--text">자격 및 조건</span></template>
            <template #txt>가입하기 전 파트너 등록 자격 요건이나 사전 준비사항을 미리 확인하세요!</template>
            <v-row class="row--sm">
                <v-col v-for="(question, index) in questions" :key="index" cols="12" lg="6">
                    <v-card color="grey lighten-5" rounded="lg" height="100%" class="pa-6 pa-lg-10">
                        <v-row class="row--sm">
                            <v-col cols="12">
                                <div class="tit tit--xs">
                                    <v-row class="row--sm">
                                        <v-col cols="auto">Q</v-col>
                                        <v-col>{{ question.q }}</v-col>
                                    </v-row>
                                </div>
                            </v-col>
                            <v-col cols="12">
                                <div class="txt txt--lg">
                                    <v-row class="row--sm">
                                        <v-col cols="auto">
                                            <span class="font-weight-bold">A</span>
                                        </v-col>
                                        <v-col>
                                            <div v-html="question.a" />
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </page-section>

        <page-section class="page-section--last pt-0">
            <template #tit>파트너 <span class="primary--text">가입 절차</span></template>
            <template #txt>가입하기 전 파트너 등록 자격 요건이나 사전 준비사항을 미리 확인하세요!</template>

            <v-row justify="center" class="row--xxl">
                <v-col cols="12">
                    <membership-steps />
                </v-col>
                <v-col cols="auto">
                    <v-btn to="/join" color="primary" class="v-size--xx-large">
                        <span class="font-weight-bold">파트너 등록하기</span>
                        <v-img src="/images/icon/icon-arrow-right.svg" alt="" class="ml-10px" />
                    </v-btn>
                </v-col>
                <v-col cols="12">
                    <v-card img="/images/partner/banner.jpg" rounded="xl" class="px-20px py-30px pa-lg-60px">
                        <v-row align="center" class="row--lg">
                            <v-col>
                                <div class="tit white--text">
                                    <div class="tit--xs">추가로 궁금한 점이 있으신가요?</div>
                                    <div class="tit--sm">온라인 상담채널로 문의주세요.</div>
                                </div>
                            </v-col>
                            <v-col cols="12" lg="auto">
                                <v-btn color="white" min-width="160px" rounded="10" x-large @click="handleClick">문의하기</v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/components/client/templates/client-page.vue";
import PageSection from "@/components/client/templates/page-section.vue";
import MembershipSteps from "@/components/client/dumb/membership-steps.vue";

export default {
    components: {
        ClientPage,
        PageSection,
        MembershipSteps,
    },
    data() {
        return {
            items: [
                {
                    title: "높은 품질의 제품 공급",
                    text: "오랜 연구개발로 입증된 <br class='d-none d-xl-block' />인기 건강제품을 파트너로서 판매",
                },
                {
                    title: "마진 및 수익 지원",
                    text: "경쟁력 있는 공급가 및  판매 수수료 <br class='d-none d-xl-block' />제공으로 안정적 수익 구조",
                },
                {
                    title: "마케팅 지원",
                    text: "온라인 판매에 익숙한 젊은 셀러를 위해 <br class='d-none d-xl-block' />교육자료 제공, 프로모션 공동 진행",
                },
                {
                    title: "전담 지원",
                    text: "전담 관리자 배치 및 커뮤니티를 통한 <br class='d-none d-xl-block' />정보 공유 등 파트너 네트워크 형성 지원",
                },
            ],
            questions: [
                {
                    q: "개인도 등록할 수 있나요, 꼭 사업자여야 하나요?",
                    a: "네, 리본바이옴 파트너는 사업자 회원 전용입니다. <br class='d-none d-xl-block' />개인 사업자 또는 법인 사업자 등록증이 필요합니다.",
                },
                {
                    q: "만 19세 이상이면 누구나 신청 가능한가요?",
                    a: "네, 만 19세 이상이며 사업자등록증 보유자라면 누구나 신청 가능합니다",
                },
                {
                    q: "파트너 등록에 비용이 발생하나요?",
                    a: "아니요. 가입 자체는 무료입니다. 다만 제품 판매를 위한 초기 발주(사입형) <br class='d-none d-xl-block' />또는 위탁 보관 재고 입고 시 상품 구매가 필요합니다.",
                },
                {
                    q: "온라인 판매 경험이 없어도 등록 가능한가요?",
                    a: "가능합니다. 자사몰/스마트스토어/SNS 판매 채널 초기 가이드와 <br class='d-none d-xl-block' />마케팅 자료가 함께 제공되어 더욱 수월한 운영이 가능합니다",
                },
                {
                    q: "재고를 꼭 사입해야 하나요?",
                    a: "사입 방식과 위탁 방식(당사 창고 보관 및 발송 대행) 중 선택 가능합니다. <br class='d-none d-xl-block' />단, 위탁 방식도 최소 10박스 단위 사입 후 보관됩니다.",
                },
                {
                    q: "위탁판매 방식으로 운영하려면 어떤 조건이 필요한가요?",
                    a: "최소 10박스 단위로 제품을 구매하신 후, 리본바이옴 창고에 보관 요청하시면 <br class='d-none d-xl-block' />주문 접수 시마다 당사에서 고객에게 직접 배송해드립니다.",
                },
                {
                    q: "정산이나 마진은 어떻게 이뤄지나요?",
                    a: "제품은 도매가로 공급되며, 판매가는 기존 판매가 대비 10% 범위 내에서 <br class='d-none d-xl-block' />자율 설정합니다. 위탁배송의 경우, 건별 택배비와 배송대행 수수료는 <br class='d-none d-xl-block' />주문 건별로 즉시 결제됩니다.",
                },
                {
                    q: "가입 후 언제부터 판매가 가능한가요?",
                    a: "가입 후 승인을 거쳐 마이페이지가 생성되면 즉시 발주 및 판매 활동이 <br class='d-none d-xl-block' />가능합니다.(승인 절차는 영업일 기준 1~2일 소요)",
                },
                {
                    q: "해외 수출도 가능한가요?",
                    a: "네, 파트너가 원하시는 경우 OEM/ODM 제품 수출 또는 완제품 수출 <br class='d-none d-xl-block' />모두 가능합니다. 영문 패키지, 서류(HS Code, CoA, 성분분석표 등) 제공이 <br class='d-none d-xl-block' />가능하며, 별도 상담 후 진행됩니다.",
                },
                {
                    q: "정상 유통가 이하로 싸게 팔면 불이익이 있나요?",
                    a: "네, 제품을 지나치게 저렴하게 판매하거나, 당근마켓 등 중고마켓에서 과도한 <br class='d-none d-xl-block' />저가 판매 시 자격 박탈 및 손해배상 책임이 발생할 수 있습니다. <br class='d-none d-xl-block' />정책 위반은 즉시 제재 대상이며, 브랜드 이미지 보호를 위해 엄격히 운영됩니다",
                },
            ],
        };
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
    },
    methods: {
        handleClick() {
            if (!this.accessToken) {
                alert("로그인이 필요합니다.");
                this.$router.push("/login");
            } else {
                this.$router.push("/mypage/questions");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.page-section--first {
    background: url(/images/partner/bg.jpg) no-repeat center / cover;
}
.partner-card {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}
@media (min-width: 1024px) {
    .partner-card {
        min-height: 230px;
    }
}
</style>